import { ReactElement } from 'react';
import { List, ListItem } from '@op/opds.opux';
import { Message } from '@messageformat/react';
import { color } from '@op/opds.tokens';
import { ReactComponent as Line } from '../../../images/line.svg';
import { ReactComponent as Rectangle } from '../../../images/rectangle.svg';

interface Props {
  percentages: {
    x: number;
    y: number;
  };
}

const ProfitRiskChartLabel = (props: Props): ReactElement => {
  const { percentages } = props;
  return (
    <List
      border="none"
      size="tiny"
      indented
      style={{
        display: 'inline-block',
        textAlign: 'left',
        marginTop: 0,
        marginBottom: 0,
      }}
    >
      <ListItem style={{ display: 'inline' }}>
        <div className="investoracademy-listitem-container">
          <Line style={{ color: color.indicator.default }} aria-hidden="true" />
          <Message id="course2.part1.profitAndRiskGraphs.fund_performance" />
          {` ${percentages.x} %`}
        </div>
      </ListItem>
      <ListItem style={{ display: 'inline' }}>
        <div className="investoracademy-listitem-container">
          <Rectangle aria-hidden="true" fill={color.icon.default} />
          <Message id="course2.part1.profitAndRiskGraphs.volatility" />
          {` ${percentages.y} %`}
        </div>
      </ListItem>
    </List>
  );
};

export default ProfitRiskChartLabel;
